import React from 'react'
import { changetheme } from '../slice/themeSlice';
import { useDispatch } from 'react-redux'

export default function Changetheme() {

    const dispatch = useDispatch()






    const themes = [
        {  name: "theme-old" , rokar:"ڕوکاری یەکەم" },
        {  name: "theme-swiss", rokar:"ڕوکاری دووەم" },
        {  name: "theme-neon" , rokar:"ڕوکاری سێیەم"},
        {  name: "theme-5", rokar:"ڕوکاری چوارەم" },
        {  name: "theme-navy", rokar:"ڕوکاری پێنجەم" },
        {  name: "theme-brown", rokar:"ڕوکاری شەشەم" },

    ]


    function newtheme(col) {

        dispatch(changetheme(col));
    }



    return (
        <>

            <div className='bg-dwam w-full flex flex-row-reverse p-4'>

                <div className='flex w-full  justify-center md:flex-row-reverse flex-wrap flex-col'>

                    {themes.map((theme) => {
                        
                        return (

                            <div className={`${theme.name} mx-2   flex flex-col  md:w-44`}>
                                <h1 className='text-center p-2'>{theme.rokar}</h1>
                                <div onClick={() => { newtheme({ theme: theme.name }) }} className='flex shadow-md cursor-pointer rounded-xl flex-row md:flex-col'>
                                    <span className='bg-yakam rounded-l-lg md:rounded-l-none  w-[14.28%] md:w-full h-12 md:h-10'></span>
                                    <span className='bg-dwam w-[14.28%] md:w-full h-12 md:h-10'></span>
                                    <span className='bg-seyam w-[14.28%] md:w-full h-12 md:h-10'></span>
                                    <span className='bg-chwaram w-[14.28%] md:w-full h-12 md:h-10'></span>
                                    <span className='bg-penjam w-[14.28%] md:w-full h-12 md:h-10'></span>
                                    <span className='bg-shasham w-[14.28%] md:w-full h-12 md:h-10'></span>
                                    <span className='bg-c7 rounded-r-lg md:rounded-r-none  w-[14.28%] md:w-full h-12 md:h-10'></span>
                                </div>
                            </div>
                        )
                    })}


                </div>
            </div>
        </>
    )
}
